import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import { FilterChip } from "@volca/ui/components/ui/filter-chip";

export const ChoiceFilterChip = <TKey extends string>({
  label,
  options,
  value,
  clearKey,
  onChange,
}: {
  label: string;
  options: readonly { key: TKey; label: string }[];
  value: TKey;
  clearKey?: TKey;
  onChange: (key: TKey) => void;
}) => {
  const filtered = clearKey !== undefined && value !== clearKey;
  const shown =
    clearKey !== undefined && !filtered
      ? undefined
      : options.find((option) => option.key === value)?.label;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <FilterChip
            label={label}
            value={shown}
            active={filtered}
            placeholder={options.find((o) => o.key === clearKey)?.label}
            onClear={
              clearKey !== undefined ? () => onChange(clearKey) : undefined
            }
            icon={
              shown !== undefined && clearKey === undefined ? (
                <CaretDownIcon
                  aria-hidden
                  className="size-4 shrink-0 text-subtle"
                />
              ) : undefined
            }
          />
        }
      />
      <DropdownMenuContent align="start" className="min-w-48">
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={(key) => onChange(key as TKey)}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem
              closeOnClick
              key={option.key}
              value={option.key}
            >
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
